import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import authStore from '../auth-store'
import authUtils from './auth-utils'
import { IUser } from '../../../model/user'
import logout from './logout'
import authResult from '@/store/auth/actions/auth-result';
import saveState from '@/store/auth/actions/save-state';

export default async function authenticate(context: BareActionContext<AuthState, RootState>): Promise<boolean>
{
    return new Promise<boolean>((resolve, reject) => {
        saveState(context).then(() => {
            if (authStore.isAuthenticated) {
                return resolve(true)
            } else {
                authUtils.authService.preAuth().then((user: IUser | null) => {
                    return authResult(context, user)
                }).catch((err) => {
                    console.log('authenticate: error in preAuth: %j', err)
                    logout(context)
                    return resolve(false)
                })
            }
        })
    })
}
